import { CancelToken } from "axios";
import { IPasswordlessSMSFlowCommand } from "../../Common/domain/src/api/command";
import { ICommandResult } from "../../Common/domain/src/api/commandResult";
import { QueryResult } from "../../Common/domain/src/api/queryResult";
import { axiosClient } from "../../Common/api/axiosClient"; 
import { getLocale } from "../../Common/localization/localizationHelper";

export class passwordlessClient extends axiosClient {  

    async startPasswordlessFlow(token: string, body: IPasswordlessSMSFlowCommand): Promise<ICommandResult> {
        let action = "/api/v1/useraccounts/start-passwordless-flow?";
        const locale = getLocale();
        
        if (locale !== undefined && locale !== null)
            action += "ui_locales=" + encodeURIComponent("" + locale) + "&";

        return await this.post<IPasswordlessSMSFlowCommand>(action, body,this.Authorize(token));
    }

    async verifySmsCode(token: string, code: string | null | undefined, phoneNumber: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ICommandResult> {
        let action = "/api/v1/useraccounts/verify-sms-code?";

        if (code !== undefined && code !== null)
            action += "Code=" + encodeURIComponent("" + code) + "&";

        if (phoneNumber !== undefined && phoneNumber !== null)
            action += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";

        action = action.replace(/[?&]$/, "");
       
        return await this.post(action, null, this.Authorize(token));

    }

    async resendCode(token: string, phoneNumber: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<ICommandResult> {
        let action = "/api/v1/useraccounts/resend-code?";
        const locale = getLocale();
        if (phoneNumber !== undefined && phoneNumber !== null)
          action += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
       
        if (locale !== undefined && locale !== null)
          action += "ui_locales=" + encodeURIComponent("" + locale) + "&";

          action = action.replace(/[?&]$/, "");

          return await this.post(action, null, this.Authorize(token));
    }

    async userinfo2(token: string, cancelToken?: CancelToken | undefined): Promise<QueryResult>{
        let action = "/api/v1/useraccounts/userinfo2";
        action = action.replace(/[?&]$/, "");
       
        return await this.get(action,this.Authorize(token));
    }
      
} 